import dayjs from 'dayjs';

// Русские месяцы без зависимости от локали dayjs
const MONTHS_SHORT = [
  'янв.', 'февр.', 'мар.', 'апр.', 'мая', 'июня',
  'июля', 'авг.', 'сент.', 'окт.', 'нояб.', 'дек.'
];

const MONTHS_FULL = [
  'января', 'февраля', 'марта', 'апреля', 'мая', 'июня',
  'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'
];

// Миниатюра: «10 сент. 15:00»
export function formatEventDateShort(date) {
  const d = dayjs(date);
  return `${d.date()} ${MONTHS_SHORT[d.month()]} ${d.format('HH:mm')}`;
}

// Детальная: «25 октября 2026 года, 15:00»
export function formatEventDateFull(date) {
  const d = dayjs(date);
  return `${d.date()} ${MONTHS_FULL[d.month()]} ${d.year()} года, ${d.format('HH:mm')}`;
}

// Только день и месяц: «25 октября»
export function formatEventDayMonth(date) {
  const d = dayjs(date);
  return `${d.date()} ${MONTHS_FULL[d.month()]}`;
}
